import { HttpMethod } from './types/http-util';
import { Request, RequestWithPayload } from './request';
export default {
    get: (path) => new Request({ path, method: HttpMethod.GET }),
    delete: (path) => new Request({ path, method: HttpMethod.DELETE }),
    patch: (path) => new RequestWithPayload({ path, method: HttpMethod.PATCH }),
    post: (path) => new RequestWithPayload({ path, method: HttpMethod.POST }),
    put: (path) => new RequestWithPayload({ path, method: HttpMethod.PUT }),
};
//# sourceMappingURL=rest.js.map